var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner"}),_c('p',{staticClass:"spinner-text"},[_vm._v(_vm._s(_vm.spinnerText)+"...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }